import type { CreateEnhanceProvider } from '../../types/plugin';
import type { SlateProps } from 'slate-react';
import { useEffect } from 'react';

import { cancelInsertionPaintsForEditor } from 'domains/reporter/RichTextEditor/analytics/insertionPaint';
import { useSlateStatic } from '../../core';

/**
 * Releases anchors the registry is still holding for this editor. The mark that would
 * have notified the paint is gone with the editor, so nothing else will ever release
 * them.
 */
export const InsertionPaintTeardown = ({
  children,
}: Readonly<{ children: React.ReactNode }>): React.ReactElement => {
  const editor = useSlateStatic();

  useEffect(() => () => cancelInsertionPaintsForEditor(editor), [editor]);

  return children as React.ReactElement;
};

export const enhanceProviderInsertionMark: CreateEnhanceProvider<Record<string, unknown>> =
  () => (Component: React.ComponentType<SlateProps>) =>
    function EnhanceProviderInsertionMark(props: SlateProps) {
      return (
        <Component {...props}>
          <InsertionPaintTeardown>{props.children}</InsertionPaintTeardown>
        </Component>
      );
    };

InsertionPaintTeardown.displayName = 'InsertionPaintTeardown';
